@let control = ctrl();

<mat-form-field
  [floatLabel]="floatLabel()"
  class="from-to-block form-field"
  [class.form-field--zero-margin]="isNested()"
>
  <label
    [for]="id()"
    class="fade-in move-to-input"
    [innerHTML]="label()"
  ></label>
  <input
    matInput
    [readonly]="readonly()"
    autocomplete="off"
    [placeholder]="placeholder()"
    class="disabled-logically-only"
    [class.ng-invalid]="control.touched && !control.valid"
    [class.placeholder]="!control.value"
    [name]="id()"
    [id]="id()"
    [min]="min()"
    [max]="max()"
    [formControl]="control"
    [matDatepicker]="picker"
    (dateChange)="dateChange.emit()"
  />
  <mat-datepicker-toggle matIconSuffix [for]="picker">
    <mat-icon matDatepickerToggleIcon fontIcon="calendar_month" />
  </mat-datepicker-toggle>
  <mat-datepicker
    #picker
    [touchUi]="isMobile"
    [startView]="startView()"
    (yearSelected)="chosenYearHandler($event)"
    (monthSelected)="chosenMonthHandler($event, picker)"
  />
</mat-form-field>
